<div *ngIf="isOpen" class="fixed inset-0 z-[99999] flex items-center justify-center p-4">
    <!-- Backdrop -->
    <div class="absolute inset-0 bg-black/50 transition-opacity" aria-hidden="true"></div>

    <!-- Modal Panel -->
    <div
        class="relative bg-white rounded-2xl shadow-xl w-full max-w-sm p-6 flex flex-col items-center text-center transform transition-all">

        <!-- Icon -->
        <div class="mb-4" [innerHTML]="iconSvg | safeHtml"></div>

        <!-- Title -->
        <h3 class="text-xl font-bold text-gray-900 mb-2">
            Your account has been disabled
        </h3>

        <!-- Description -->
        <p class="text-sm text-gray-500 mb-6 leading-relaxed">
            Your account was disabled on 01 Jan, 2026. For more information or to request a review. Please contact our help center.
        </p>

        <!-- Action Button -->
        <app-button variant="primary" size="md" className="w-full" (btnClick)="onBackToLogin()">
            Back to Login
        </app-button>
    </div>
</div>